<script lang="ts" module>
	import type { Snippet } from 'svelte';
	import type { ClassValue, HTMLAttributes } from 'svelte/elements';
	import type { VariantProps } from 'tailwind-variants';
	import { tv } from '../tv';
	import { CONTAINER_COLOR_VARIANTS } from '../variants';

	export const headerVariants = tv({
		base: 'flex shrink-0 items-center border-(--v-container-line) text-(--v-on-container)',
		variants: {
			variant: CONTAINER_COLOR_VARIANTS,
			size: {
				'300': 'h-[2rem]',
				'400': 'h-[2.5rem]',
				'500': 'h-[3rem]',
				'600': 'h-[3.375rem]',
				'700': 'h-[4rem]'
			}
		},
		defaultVariants: { variant: 'Surface', size: '400' }
	});

	export interface HeaderProps
		extends Omit<HTMLAttributes<HTMLElement>, 'class'>, VariantProps<typeof headerVariants> {
		as?: string;
		children?: Snippet;
		class?: ClassValue;
		ref?: HTMLElement | null;
	}
</script>

<script lang="ts">
	let {
		as = 'header',
		children,
		class: className,
		ref = $bindable(null),
		size,
		variant,
		...rest
	}: HeaderProps = $props();
</script>

<svelte:element
	this={as}
	bind:this={ref}
	class={[headerVariants({ size, variant }), className]}
	{...rest}
>
	{@render children?.()}
</svelte:element>
